import React, { useEffect, useState } from 'react';
import AuthorHeader from './AuthorHeader';
import AuthorList from './AuthorList';
import { HashRouter } from 'react-router-dom';

const CoauthorList = () => {
  const [selectedRole, setSelectedRole] = useState('all');

  const updateSelectedRoleFromHash = () => {
    const locationHash = window.location.hash.slice(2); // Remove the leading `#/`
    setSelectedRole(locationHash || 'all');
  };

  useEffect(() => {
    // Update selectedRole when component mounts
    updateSelectedRoleFromHash();

    // Add hash change listener
    window.addEventListener('hashchange', updateSelectedRoleFromHash);

    // Cleanup listener on component unmount
    return () => {
      window.removeEventListener('hashchange', updateSelectedRoleFromHash);
    };
  }, []);

  return (
    <HashRouter>
      <div>
        <AuthorHeader selectedRole={selectedRole} />
        <AuthorList selectedRole={selectedRole} />
      </div>
    </HashRouter>
  );
};

export default CoauthorList;
